import i from"styled-components";import{theme as e}from"../../../theme.js";const o=i.div`
  background-color: ${e.colors.primary[500]};
`,t=i.div`
  height: 64px;
  .desktop, .mobile {
    box-sizing: border-box;
  }
  .desktop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: ${e.maxWidth};
    margin: auto;
  }
  .mobile {
    display: none;
  }
  @media screen and (max-width: ${e.breakpoints.xl}) {
    .desktop {
      width: 100%;
      padding: 0 ${e.spacing*4}px;
    }
  }
  @media screen and (max-width: ${e.breakpoints.md}) {
    .desktop {
      display: none;
    }
    .mobile {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      padding: 0 ${e.spacing*4}px;
    }
  }
`;i.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  outline: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  padding: 0;
  background-color: unset;
  > svg {
    width: 24px;
    height: 24px;
    > g, path {
      fill: ${e.colors.shades[0]};
    }
  }
  &:hover {
    background-color: ${e.colors.primary[400]};
  }
`;export{o as Container,t as Wrapper};
